/**
 * NL vs EN promo copy for bilingual strips (snippets/ws-anniversary-promo.liquid).
 * Blocks use data-wg-notranslate; toggling is script-driven only.
 *
 * Language resolution matches assets/ws-generator.js behaviour:
 *   • document.documentElement.lang — set synchronously by wsApplyUiLang on NL/EN clicks
 *   • localStorage ws_ui_lang — same key as WS_LANG_STORAGE_KEY in ws-generator.js
 *   • Weglot.getCurrentLang() — fallback when only Weglot drives the page (never stale-wins over html/storage)
 */
(function () {
  var WS_UI_LANG_KEY = 'ws_ui_lang';

  function normalize(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).trim().split(/[-_]/)[0].toLowerCase();
    return s || null;
  }

  function langFromStorage() {
    try {
      return normalize(localStorage.getItem(WS_UI_LANG_KEY));
    } catch (_) {
      return null;
    }
  }

  function langFromWeglot() {
    try {
      if (typeof Weglot !== 'undefined' && typeof Weglot.getCurrentLang === 'function') {
        return normalize(Weglot.getCurrentLang());
      }
    } catch (_) {}
    return null;
  }

  /**
   * Single resolved tag for choosing NL vs EN promo paragraph.
   * Non-"nl" codes (e.g. fr) follow Weglot behaviour: show EN fallback copy when Dutch exists.
   */
  function currentLang() {
    var h = normalize(document.documentElement.getAttribute('lang'));
    var st = langFromStorage();
    var wg = langFromWeglot();

    if (h === 'en' || h === 'el') return h;
    if (st === 'en' || st === 'el') return st;
    if (wg === 'en' || wg === 'el') return wg;

    if (h && h !== 'nl') return h;
    if (st && st !== 'nl') return st;
    if (wg && wg !== 'nl') return wg;

    if (h === 'nl' || st === 'nl' || wg === 'nl') return 'nl';

    return 'nl';
  }

  function apply() {
    var l = currentLang();
    document.querySelectorAll('[data-ws-promo-bilingual]').forEach(function (root) {
      var nl = root.querySelector('[data-ws-promo-lang="nl"]');
      var en = root.querySelector('[data-ws-promo-lang="en"]');
      var hasNl = nl && nl.textContent.trim();
      var hasEn = en && en.textContent.trim();
      var useEnglish = hasEn && (l !== 'nl' || !hasNl);
      if (nl) nl.hidden = useEnglish;
      if (en) en.hidden = !useEnglish;
    });
  }

  function bindWeglot() {
    if (typeof Weglot !== 'undefined' && Weglot.on) {
      Weglot.on('initialized', apply);
      Weglot.on('languageChanged', apply);
      return true;
    }
    return false;
  }

  try {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'lang') {
          apply();
          return;
        }
      }
    });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  } catch (_) {}

  window.addEventListener('storage', function (e) {
    if (e.key === WS_UI_LANG_KEY) apply();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  if (!bindWeglot()) {
    var t0 = Date.now();
    var id = setInterval(function () {
      if (bindWeglot()) {
        apply();
        clearInterval(id);
      } else if (Date.now() - t0 > 10000) {
        clearInterval(id);
      }
    }, 40);
  } else {
    apply();
  }

  /** Cart AJAX replaces `main-cart-footer` HTML; re-run NL/EN visibility on injected promo strips. */
  window.wsPromoI18nApply = apply;
})();
